import React from "react"
import Layout from "../components/layout"
import { Blocks, PageBlockProps } from "../components/blocks"

interface Data<T> {
    blocks: Array<T>
    title: string
    description: string
    herobackground: string
    topcontent: {
        label: string
        header: string
        buttons: Array<{ link: string; text: string }>
    }
}

interface Props extends React.HTMLAttributes<HTMLElement> {
    location: Location
    pageContext: {
        slug: string
        mdData: Data<PageBlockProps>
    }
}

const LandingPage = ({ location, pageContext }: Props): JSX.Element => {
    const { mdData } = pageContext
    const { title, description, herobackground, topcontent, blocks } = mdData

    return (
        <Layout
            {...{ location }}
            seo={{ title: title, description: description }}
            hero={{ backgroundImage: herobackground, topcontent: topcontent }}
        >
            <Blocks blocks={blocks} />
        </Layout>
    )
}

export default LandingPage
